class Countdown extends HTMLElement {
    constructor() {
      super();
      this.intervalId = null;
      this.endTime = null;
      this.paused = false;
    }
  
    connectedCallback() {
      this.endTime = this.toDate.getTime();
      this.render();
      // Check if paused via data attribute
      if (this.hasAttribute('data-paused')) {
        this.paused = true;
      }
      if (!this.paused) {
        this.startCountdown();
      }
      // Handle window resize to update title on mobile/desktop switch
      this.handleResize = () => {
        if (!this.paused) {
          this.render();
        }
      };
      window.addEventListener('resize', this.handleResize);
    }
  
    disconnectedCallback() {
      if (this.handleResize) {
        window.removeEventListener('resize', this.handleResize);
      }
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    }
  
    render() {
      const days = this.daysUntilToDate;
      const hours = this.hoursUntilToDate % 24;
      const minutes = this.minutesUntilToDate % 60;
      const seconds = this.secondsUntilToDate % 60;
  
      const textEl = this.querySelector('[data-el="countdown.text"]');
      const container = this.querySelector('.cnt-Countdown_Container');
  
      if (this.timeIsUp()) {
        if (container) {
          container.innerHTML = '<div class="cnt-Countdown_Ended">Ended</div>';
        }
        clearInterval(this.intervalId);
        return;
      }
  
      // Build the countdown structure
      let html = '';
      
      // Determine title based on page type and device
      const pageType = this.getAttribute('data-page-type');
      const template = this.getAttribute('data-template');
      const isMobile = window.innerWidth < 750;
      const isProductPage = pageType === 'product';
      const isCollectionPage = pageType === 'collection' || template && template.includes('collection');
      const shouldShowBlackFriday = isProductPage || (isCollectionPage && isMobile);
      
      // Title
      const titleText = shouldShowBlackFriday ? 'SALE ENDS IN:' : 'SALE ENDS IN:';
      html += `<div class="cnt-Countdown_Title">${titleText}</div>`;
      
      // Countdown boxes - Horizontal Layout
      html += '<div class="cnt-Countdown_Boxes">';
      
      // Helper function to create digit boxes
      const createTimeUnit = (value, label) => {
        const digits = String(value).padStart(2, '0').split('');
        return `<div class="cnt-Countdown_TimeUnit">
          <div class="cnt-Countdown_Digits">
            <div class="cnt-Countdown_Number">${digits[0]}</div>
            <div class="cnt-Countdown_Number">${digits[1]}</div>
          </div>
          <div class="cnt-Countdown_Label">${label}</div>
        </div>`;
      };
      
      // Colon SVG
      const colonSvg = '<svg width="8" height="42" viewBox="0 0 8 42" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 8.00781V0H8.00781V8.00781H0ZM0 41.4844V33.4766H8.00781V41.4844H0Z" fill="currentColor"/></svg>';
      
      // Days
      html += createTimeUnit(days, 'DAYS');
      
      // Colon separator
      html += `<div class="cnt-Countdown_Colon">${colonSvg}</div>`;
      
      // Hours
      html += createTimeUnit(hours, 'HOURS');
      
      // Colon separator
      html += `<div class="cnt-Countdown_Colon">${colonSvg}</div>`;
      
      // Minutes
      html += createTimeUnit(minutes, 'MINUTES');
      
      // Colon separator
      html += `<div class="cnt-Countdown_Colon">${colonSvg}</div>`;
      
      // Seconds
      html += createTimeUnit(seconds, 'SECONDS');
      
      html += '</div>';
      
      if (container) {
        container.innerHTML = html;
      } else if (textEl) {
        textEl.innerHTML = html;
      }
    }
  
    startCountdown() {
      if (this.paused) return;
      this.endTime = this.toDate.getTime();
  
      this.intervalId = setInterval(() => {
        if (!this.paused) {
          this.render();
        }
      }, 1000);
    }
  
    pause() {
      this.paused = true;
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }
  
    resume() {
      this.paused = false;
      if (!this.intervalId) {
        this.startCountdown();
      }
    }
  
    timeIsUp() {
      if (!this.endTime) return false;
      return Date.now() >= this.endTime;
    }
  
    get toDate() {
      const [date, time] = this.getAttribute('data-countdown-date').split(' ');
      const [year, month, day] = date.split('-');
      const [hour = '00', minute = '00', second = '00'] = (time || '00:00:00').split(':');
  
      return new Date(year, month - 1, day, hour, minute, second);
    }
  
    get now() {
      return new Date();
    }
  
    get daysUntilToDate() {
      return this.differenceInDays(this.toDate, this.now);
    }
  
    get hoursUntilToDate() {
      return this.differenceInHours(this.toDate, this.now);
    }
  
    get minutesUntilToDate() {
      return this.differenceInMinutes(this.toDate, this.now);
    }
  
    get secondsUntilToDate() {
      return this.differenceInSeconds(this.toDate, this.now);
    }
  
    differenceInDays(dateA, dateB) {
      const diffTime = dateA.getTime() - dateB.getTime();
      return Math.floor(diffTime / (1000 * 60 * 60 * 24));
    }
  
    differenceInHours(dateA, dateB) {
      const diffTime = dateA.getTime() - dateB.getTime();
      return Math.floor((diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    }
  
    differenceInMinutes(dateA, dateB) {
      const diffTime = dateA.getTime() - dateB.getTime();
      return Math.floor((diffTime % (1000 * 60 * 60)) / (1000 * 60));
    }
  
    differenceInSeconds(dateA, dateB) {
      const diffTime = dateA.getTime() - dateB.getTime();
      return Math.floor((diffTime % (1000 * 60)) / 1000);
    }
  }
  
  customElements.define('countdown-element', Countdown);